import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getCompanyMSNoteListData } from './mockData'
import type { ICompanyMSNote } from '~/types/note/models'

export const {
  getNotes: getCompanyMSNotes,
  postNote: postCompanyMSNote,
  patchNote: patchCompanyMSNote,
  deleteNote: deleteCompanyMSNote,
  handlers,
} = makeNoteAPIs<ICompanyMSNote>({
  apiPathEntityNamePrefix: 'companyms',
  getNoteListDataFn: getCompanyMSNoteListData,
})
